// extracted by mini-css-extract-plugin
export default {"result-view-container":"ResultView_result-view-container__dEf+5"};